import React from "react";
import "./App.css";
import CardActionArea from "@material-ui/core/CardActionArea";
import { useHistory } from "react-router-dom";

function LandingPage() {
  let history = useHistory();
  return (
    <div>
      <div className="landingPageIntroText">
        Where do you want to use your graphic?
      </div>
      <div className="landingPageFluid landingPageFluidDirection">
        <div className="paperGradient1">
          <CardActionArea
            className="paperCardAction"
            onClick={() => {
              history.push("/layout/1");
            }}
          ></CardActionArea>
          <div className="paperGradient1Box" />
        </div>
        <div className="paperGradient2">
          <CardActionArea
            className="paperCardAction"
            onClick={() => {
              history.push("/layout/2");
            }}
          ></CardActionArea>
          <div className="paperGradient2Box" />
        </div>
        <div className="paperGradient3">
          <CardActionArea
            className="paperCardAction"
            onClick={() => {
              history.push("/layout/3");
            }}
          ></CardActionArea>
          <div className="paperGradient3Box" />
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
